<script lang="ts">
import { defineComponent, reactive, computed } from 'vue'
import LayoutStoryCardsCols from '@/components/contents/LayoutStoryCardsCols.vue'
import stateInitializer from '@/models/stateInitializer'
import {
  themePath,
  storyPath,
} from '@/generated/railsRoutes'


export default defineComponent({
  name: 'StoriesMain',

  components: {
    LayoutStoryCardsCols,
  },

  setup() {
    // constants
    const IMAGE_OPTIONS = {
      width: {
        pc: 238,
        sp: 214,
      },
      height: {
        pc: 104,
        sp: 80,
      },
    } as const

    interface State {
      themes: ThemeItem[],
    }
    const state: State = reactive({
      themes: [],
    })
    stateInitializer(state, 'main')

    const themeItems = computed<ThemeItem[]>(() => {
      return state.themes.map((theme) => {
        const _stories = theme.stories?.map((story) => {
          const _story = {
            ...story,
            to: storyPath({ id: story.id }),
            themeId: theme.id,
          }
          return _story
        })

        return {
          ...theme,
          stories: _stories,
        }
      })
    })

    return {
      // constants
      IMAGE_OPTIONS,

      // routes
      themePath,
      storyPath,

      // data
      state,

      // computed
      themeItems,
    }
  },
})
</script>

<template>
  <section class="section">
    <template
      v-for="theme in themeItems"
      :key="theme.id">
      <section
        v-if="theme.stories?.length"
        class="section">
        <h2 class="h2 u-text__xx-large u-text__bold">
          {{ theme.title }}
        </h2>

        <LayoutStoryCardsCols
          :items="theme.stories"
          :cols="{ pc: 4, sp: 2 }"
          :heading-options="{ maxLine: 2 }"
          :image-options="IMAGE_OPTIONS"
          has-items-total />

        <p class="p u-text__right u-margin__larger">
          <a
            class="a u-text__small u-action__forward"
            :href="themePath({ id: theme.id })">
            {{ theme.title }}の特集をもっと見る
          </a>
        </p>
      </section>
    </template>
  </section>
</template>
